import { Reference } from '@approvalmax/types';
import { domain } from 'modules/data';

import { messages } from './lineAmountType.messages';

export enum BackendLineAmountType {
    TaxExclusive = 'TaxExclusive',
    TaxInclusive = 'TaxInclusive',
    NoTax = 'NoTax',
}

export const lineAmountTypeReferences: (Reference & { backendId: BackendLineAmountType })[] = [
    {
        id: domain.LineAmountType.TaxExclusive,
        text: messages.taxExclusive,
        backendId: BackendLineAmountType.TaxExclusive,
    },
    {
        id: domain.LineAmountType.TaxInclusive,
        text: messages.taxInclusive,
        backendId: BackendLineAmountType.TaxInclusive,
    },
    {
        id: domain.LineAmountType.NoTax,
        text: messages.noTax,
        backendId: BackendLineAmountType.NoTax,
    },
];

export function findLineAmountType(id: domain.LineAmountType): Reference | null {
    return lineAmountTypeReferences.find((x) => x.id === id) || null;
}
